<div class="wrapper">
  <div class="row">
    <div style="width: 100%; padding: 0% !important;">
      <h1 class="pageTitle">{{ pageTitle }}</h1>
      <app-notifications style="text-align: center"
        [notification]="'booking_details_page_notification_banner_child'"></app-notifications>
      <div [innerHTML]="guidanceMsg"></div>
      <hr />
    </div>

    <div style="width: 100%; padding: 0% !important;">
      <div class="card mt-4 bb-panel">
        <form [formGroup]="permitQuestionsForm" autocomplete="off" class="col-sm-12 col-md-12 col-lg-12"
          autocomplete="on">
          <!-- <h4 class="mt-1 pb-4">{{'COMMON.BOOKING_INFORMATION' | translate}}</h4> -->
          <div *ngFor="let question of permitQuestions">
            <ng-container *ngIf="(foundPermit || 
              question.id.includes('please_enter_your_vehicle_registration') ||
              question.id.includes('send_verification_code') ||
              question.id.includes('please_enter_your_verification') ) && !question.hidden">

              <div *ngIf="question.visible && question.detail_type == 'heading' && 
              !(question.field === 'eligible_to_renew_existing_permit' && !canRenew()) && 
               !(question.field === 'ineligible_to_renew_existing_permit' && canRenew())">
                <p>
                  <b style="color: red;"
                    *ngIf="question.field === 'ineligible_to_renew_existing_permit'">{{parseHeading(question.name)}}</b>
                  <b style="color: green;"
                    *ngIf="question.field === 'eligible_to_renew_existing_permit'">{{parseHeading(question.name)}}</b>
                  <b
                    *ngIf="question.field !== 'eligible_to_renew_existing_permit' && question.field !== 'ineligible_to_renew_existing_permit' ">{{parseHeading(question.name)}}</b>
                  <br *ngIf="question.help_text" />
                  <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                  </span>
                </p>
              </div>
              <div *ngIf="question.visible && question.detail_type == 'datatable'">
                <div class="bb-panel">
                  <p>
                    <b>{{ question.name }}</b>
                  </p>
                  <div class="row panel-row" *ngFor="let row of question.tablerows">
                    <div class="col-sm-6">{{row.rowName}}</div>
                    <div class="col-sm-6">{{getDataTableRowValue(row)}}</div>
                  </div>
                </div>
                <br>
              </div>
              <div *ngIf="question.visible && question.detail_type == 'button'">
                <div>
                  <button class="btn btn-primary col-sm-4 mb-0 govuk-button button-sizer question-button-sizer"
                    [ngClass]="{
                    'button-not-selected':!bookingForm[question.reference].value}"
                    (click)="toggleButton(question.id)">{{question.name}}</button>

                </div>
              </div>

              <div class="form-group" *ngIf="question.detail_type == 'upload' && question.visible">
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <label for="{{ question.name }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                </span>
                <br />
                <input class="govuk-file-upload" id="{{ question.reference}}" type="file" multiple
                  (change)="uploadTest(question, $event)" />
                <br />
                <!-- name="{{question.name}}" we just set this thing's value in the upload test method -->
                <ng-container *ngIf="uploadQuestionFiles[question.id]">
                  <ng-container *ngIf="uploadQuestionFiles[question.id].length > 0">
                    <table class="" style="width: 70%">
                      <!-- <caption class="">File information
                                    </caption> -->
                      <thead class="">
                        <tr class="">
                          <th scope="col" style="width: 60%" class="help-text">
                            Name
                          </th>
                          <th scope="col" style="width: 20%" class="help-text">
                            Size
                          </th>
                          <th scope="col" style="width: 20%" class="help-text">
                            &nbsp;
                          </th>
                        </tr>
                      </thead>
                      <tbody class="">
                        <tr class="" *ngFor="
                          let file of uploadQuestionFiles[question.id];
                          index as i
                        ">
                          <td style="width: 60%" class="help-text">
                            {{ file.value.file.name }}
                          </td>
                          <td style="width: 20%" class="help-text">
                            {{
                            (file.value.file.size / (1024 * 1024)).toFixed(3)
                            }}MB
                          </td>
                          <td style="width: 20%" class="help-text">
                            <a class="" (click)="removeFileAtIndex(question, i, $event)" href="#">Remove
                              <span class="govuk-visually-hidden">file</span></a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                </ng-container>
                <span *ngIf="question.help_text">
                  <!-- br instead of changing css -->
                  <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                  </span>
                  <br *ngIf="question.help_text" />
                  <br *ngIf="question.help_text" />
                </span>
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                </span>
              </div>

              <div class="form-group" *ngIf="question.visible && question.detail_type == 'text'">
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !question.id.includes('please_enter_your_vehicle_registration') &&
                  !question.id.includes('please_enter_your_verification') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <label for="{{ question.name }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                </span>

                <ng-container *ngIf="
                  question.name === 'Vehicle make' ||
                  question.name === 'Vehicle model' ||
                  question.name === 'Vehicle colour'
                ">
                  <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                  {{getAlwaysDisabled(question.reference)}}
                  <span *ngIf="getAlwaysDisabled(question.reference)">
                    <input id="{{ question.reference}}" maxlength="20" type="text" class="form-control"
                      formControlName="{{ question.reference }}" attr.aria-label="{{ question.name }} input field"
                      oninput="this.value = this.value.toUpperCase()" disabled />
                  </span>
                  <span *ngIf="!getAlwaysDisabled(question.reference)">
                    <input id="{{ question.reference}}" maxlength="20" type="text" class="form-control"
                      formControlName="{{ question.reference }}" attr.aria-label="{{ question.name }} input field"
                      oninput="this.value = this.value.toUpperCase()" />

                  </span>
                  <!-- br instead of changing css -->
                  <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                  </span>
                  <br *ngIf="question.help_text" />
                  <span *ngIf="
                    !question.id.includes('postcode') &&
                    !question.id.includes('please_enter_your_vehicle_registration') &&
                    !question.id.includes('please_enter_your_verification') &&
                    !(
                      question.id.includes('address') &&
                      !question.id.includes('email')
                    )
                  ">
                    <div *ngIf="
                      submitted &&
                      bookingForm[question.reference].errors?.required
                    " role="alert" tabindex="0" class="invalid-feedback">
                      {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                    </div>
                  </span>
                </ng-container>

                <ng-container *ngIf="
                  !(
                    question.name === 'Vehicle make' ||
                    question.name === 'Vehicle model' ||
                    question.name === 'Vehicle colour' ||
                    question.name === 'Vehicle registration' ||
                    question.id.includes('postcode') ||
                    question.id.includes('please_enter_your_vehicle_registration') ||
                    question.id.includes('please_enter_your_verification') ||
                    (question.id.includes('address') &&
                      !question.id.includes('email'))
                  )
                ">
                  <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                  <!-- <input id="{{question.name}}" *ngIf="question.reference != 4" type="text"
                                    class="form-control " formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase()">
                                <input id="{{question.name}}" *ngIf="question.reference === 4" type="text"
                                    class="form-control " formControlName="{{question.reference}}"
                                    attr.aria-label="{{question.name}} input field"
                                    oninput="this.value = this.value.toUpperCase()"> -->
                  <input id="{{ question.reference}}" type="text" class="form-control"
                    *ngIf="question.field === 'manual_vehicle_registration'"
                    oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()"
                    (blur)="this.hardCodedRules(question)" formControlName="{{ question.reference }}"
                    attr.aria-label="{{ question.name }} input field" />
                  <input id="{{ question.reference}}" type="text" class="form-control"
                    *ngIf="question.field !== 'manual_vehicle_registration'" (blur)="this.hardCodedRules(question)"
                    formControlName="{{ question.reference }}" attr.aria-label="{{ question.name }} input field" />
                  <!-- br instead of changing css -->
                  <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                  </span>
                  <br *ngIf="question.help_text" />
                  <span *ngIf="
                    !question.id.includes('postcode') &&
                    !question.id.includes('please_enter_your_vehicle_registration') &&
                    !question.id.includes('please_enter_your_verification') &&
                    !(
                      question.id.includes('address') &&
                      !question.id.includes('email')
                    )
                  ">
                    <div *ngIf="this.registrationUsed && question.field === 'manual_vehicle_registration'">
                      <span style="font-weight: 600; color: red">
                        A permit already exists for this vehicle. Please contact us at TBC
                      </span>
                    </div>
                    <div *ngIf="
                      submitted &&
                      bookingForm[question.reference].errors?.required
                    " role="alert" tabindex="0" class="invalid-feedback">
                      {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                    </div>
                  </span>
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.mismatch &&
                    question.reference === 'verify_email_address'
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ 'COMMON.EMAIL_MISMATCH' | translate }}
                  </div>
                </ng-container>
                <ng-container *ngIf="question.name === 'Vehicle registration'">
                  <div>
                    <div class="row ml-0 mr-0">
                      <div class="col-sm-8" style="padding: 0% !important;">
                        <input id="{{ question.reference}}" (keydown.space)="$event.preventDefault()"
                          (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                          formControlName="{{ question.reference }}" role="textbox"
                          oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()" />
                      </div>
                      <button type="button" class="btn btn-primary col-sm-4 mb-0 govuk-button button-sizer"
                        [disabled]="!bookingForm[question.reference].valid" (click)="getVehicle()">
                        Find vehicle
                      </button>
                    </div>

                    <!-- br instead of changing css -->
                    <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                    </span>
                    <br *ngIf="question.help_text" />

                    <span *ngIf="vehicleStatus == 1" style="color: green; font-weight: 600">
                      Vehicle details confirmed by DVLA, please proceed.
                    </span>

                    <span *ngIf="vehicleStatus == 2" style="color: red; font-weight: 600">
                      Vehicle details not confirmed by DVLA, please try again, or contact the Waste Team for help on TBC
                    </span>

                    <span *ngIf="vehicleStatus == 3" style="color: red; font-weight: 600">
                      Vehicle details not confirmed by DVLA, please try again, or contact the Waste Team for help on TBC
                    </span>

                    <!-- <div *ngIf="motStatusInvalid" style="color: red; font-weight: 600">
                      The vehicle entered does not have a valid MOT. You cannot proceed with this vehicle.
                    </div>

                    <div *ngIf="taxStatusInvalid" style="color: red; font-weight: 600">
                      The vehicle entered is not taxed. You cannot proceed with this vehicle.
                    </div> -->

                    <div *ngIf="this.registrationUsed">
                      <span style="font-weight: 600; color: red">
                        A permit already exists for this vehicle. Please contact us at TBC
                      </span>
                    </div>
                  </div>
                  <span *ngIf="
                    !question.id.includes('postcode') &&
                    !(
                      question.id.includes('address') &&
                      !question.id.includes('email')
                    )
                  ">
                    <div *ngIf="
                      submitted &&
                      bookingForm[question.reference].errors?.required
                    " role="alert" tabindex="0" class="invalid-feedback">
                      {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                    </div>
                  </span>
                </ng-container>

                <span *ngIf="question.help_text && question.name === 'Vehicle colour'" class="help-text" tabindex="0"
                  [innerHTML]="
                  'Please only note the nearest base colour, e.g. silver'
                ">
                </span>

                <div *ngIf="
                  submitted && (bookingForm[question.reference].errors?.pattern || bookingForm[question.reference].errors?.email)
                " role="alert" tabindex="0" class="invalid-feedback">
                  Please enter a valid {{ question.name }}
                </div>
                <ng-container *ngIf="question.id.includes('please_enter_your_vehicle_registration')">
                  <div class="form-group">
                    <label for="{{ question.id }}"><span aria-hidden="true" class="form-field-required-marker">
                        *</span>
                      {{ question.name }}</label>

                    <div class="row ml-0 mr-0">
                      <div class="col-sm-8" style="padding: 0% !important;">
                        <input id="{{ question.id }}" (keydown.space)="$event.preventDefault()"
                          (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                          formControlName="{{ question.id }}" role="textbox"
                          oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()" />
                      </div>
                      <button type="button" class="btn btn-primary col-sm-4 mb-0"
                        [disabled]="!bookingForm[question.id].value" (click)="sendVerification(question.id)">
                        Send verification code
                      </button>
                    </div>
                    <!-- br instead of changing css -->
                    <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                    </span>
                    <br *ngIf="question.help_text" />
                    <div *ngIf="bookingForm[question.id].errors?.regNotFound" role="alert" tabindex="0"
                      class="invalid-feedback">
                      {{ bookingForm[question.id].errors?.regNotFound }}
                    </div>
                    <div *ngIf="
                      submitted && bookingForm[question.id].errors?.required
                    " class="invalid-feedback">
                      <div *ngIf="bookingForm[question.id].errors.required" role="alert" tabindex="0">
                        Registration is required
                      </div>
                    </div>
                    <div *ngIf="sent" class="invalid-feedback" style="color:#008000;">
                      <div role="alert" tabindex="0">
                        Your verification code has been emailed to the email address on your permit
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="question.id.includes('please_enter_your_verification')">
                  <div class="form-group">
                    <label for="{{ question.id }}"><span aria-hidden="true" class="form-field-required-marker">
                        *</span>
                      {{ question.name }}</label>

                    <div class="row ml-0 mr-0">
                      <div class="col-sm-8" style="padding: 0% !important;">
                        <input id="{{ question.id }}" (keydown.space)="$event.preventDefault()"
                          (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                          formControlName="{{ question.id }}" role="textbox"
                          oninput="this.value = this.value.replace(/\s/g, '')" />
                      </div>
                      <button type="button" class="btn btn-primary col-sm-4 mb-0"
                        [disabled]="!bookingForm[question.id].value" (click)="verifyCode(question.id)">
                        Verify Code
                      </button>
                    </div>
                    <!-- br instead of changing css -->
                    <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                    </span>
                    <br *ngIf="question.help_text" />
                    <div *ngIf="bookingForm[question.id].errors?.codeNotFound" role="alert" tabindex="0"
                      class="invalid-feedback">
                      {{ bookingForm[question.id].errors?.codeNotFound }}
                    </div>
                    <div *ngIf="
                      submitted && bookingForm[question.id].errors?.required
                    " class="invalid-feedback">
                      <div *ngIf="bookingForm[question.id].errors.required" role="alert" tabindex="0">
                        Verification code required
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="question.id.includes('postcode')">
                  <div class="form-group">
                    <label for="{{ question.id }}"><span aria-hidden="true" class="form-field-required-marker">
                        *</span>
                      {{ question.name }}</label>

                    <div class="row ml-0 mr-0">
                      <div class="col-sm-8" style="padding: 0% !important;">
                        <input id="{{ question.id }}" (keydown.space)="$event.preventDefault()"
                          (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                          formControlName="{{ question.id }}" role="textbox"
                          oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()" />
                      </div>
                      <button type="button" class="btn btn-primary col-sm-4 mb-0 btn-lookup"
                        *ngIf="!addressLookupStatusComponent.getAddressLookupUnavailable()"
                        [disabled]="!bookingForm[question.id].value" (click)="getAddress(question.id)">
                        {{ 'COMMON.FIND_ADDRESS' | translate }}
                      </button>
                      <div *ngIf="addressLookupStatusComponent.getAddressLookupUnavailable()" class="col-sm-4 mb-0"
                        style="margin-top: -3px;">
                        <span style="font-weight: 600; color: #DC3545;">
                          Our address lookup is currently experiencing technical difficulties. Please try again later.
                        </span>
                      </div>
                    </div>
                    <!-- br instead of changing css -->
                    <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                    </span>
                    <br *ngIf="question.help_text" />
                    <div *ngIf="bookingForm[question.id].errors?.addressNotFound" role="alert" tabindex="0"
                      class="invalid-feedback">
                      {{ bookingForm[question.id].errors?.addressNotFound }}
                    </div>
                    <div *ngIf="bookingForm[question.id].errors?.invalidPostcode" role="alert" tabindex="0"
                      class="invalid-feedback">
                      {{ bookingForm[question.id].errors?.invalidPostcode }}
                    </div>
                    <div *ngIf="
                      submitted && bookingForm[question.id].errors?.required
                    " class="invalid-feedback">
                      <div *ngIf="bookingForm[question.id].errors.required" role="alert" tabindex="0">
                        Postcode is required
                      </div>
                      <div *ngIf="
                        submitted &&
                        bookingForm[question.id.replace('postcode', 'address')]
                          .errors?.required
                      " class="invalid-feedback">
                        <div *ngIf="
                          bookingForm[
                            question.id.replace('postcode', 'address')
                          ].errors.required && !showingAddresses[question.id]
                        " role="alert" tabindex="0">
                          Please click 'FIND ADDRESS'
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <span *ngIf="addresses[question.id].length > 0 && isInLocalArea[question.id]">
                      <label for="{{ question.id.replace('postcode', 'address') }}">
                        <span aria-hidden="true" class="form-field-required-marker" *ngIf="question.required">*</span>
                        {{ question.name.replace('postcode', 'address').replace('Postcode', 'Address') }}
                      </label>

                      <select id="{{ question.id.replace('postcode', 'address') }}"
                        formControlName="{{question.id.replace('postcode', 'address')}}"
                        (change)="checkAddressExistingPermit(question.id.replace('postcode', 'address'))"
                        class="form-select" attr.aria-label="Select address">
                        <option value="">Please select</option>
                        <option *ngFor="let item of addresses[question.id]" [ngValue]="item">
                          {{ item?.address.ADDRESS }}
                        </option>
                      </select>
                      <!-- br instead of changing css -->
                      <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                      </span>
                      <br *ngIf="question.help_text" />
                    </span>
                    <!-- <div *ngIf="addressLookupStatusComponent.getAddressLookupUnavailable()" class="mt-2">
                      <label for="{{question.id.replace('postcode', 'address')}}">
                        <span aria-hidden="true" class="form-field-required-marker">*</span>
                        Address where the waste is coming from.
                      </label>
                      <input type="text" class="form-control" id="{{question.id.replace('postcode', 'address')}}"
                        formControlName="{{question.id.replace('postcode', 'address')}}"
                        attr.aria-label="Enter address manually" />
                      <br>
                      <br>
                    </div> -->
                    <div *ngIf="
                      submitted &&
                      bookingForm[question.id.replace('postcode', 'address')]
                        .errors &&
                      !bookingForm[question.id].errors?.required
                    " class="invalid-feedback">
                      <div *ngIf="
                        bookingForm[question.id.replace('postcode', 'address')]
                          .errors.required
                      " role="alert" tabindex="0">
                        An address is required
                      </div>
                    </div>
                    <div *ngIf="
                      showingAddresses[question.id] &&
                      !isInLocalArea[question.id]
                    ">
                      <span style="font-weight: 600; color: red">
                        Only residents living in the Dorset Council area can apply for a permit
                      </span>
                    </div>
                    <div *ngIf="
                      showingAddresses[question.id] &&
                      this.addressUsed
                    ">
                      <span style="font-weight: 600; color: red">
                        A permit already exists for this address. Please contact us at TBC
                      </span>
                    </div>
                    <!-- <div *ngIf="this.customerDetailsForm.value.selectedAddress[question.id.replace('postcode','address')]">
                                                <span *ngIf="!localAddress()" style="font-weight:bolder; color: red;">
                                                    As the waste does not originate from within the Kent administrative area, a £10
                                                    cross-border fee will be payable on arrival (card payments only).
                                                    Please see our <a target="_blank" href="https://kent.gov.uk/hwrccrossborder">cross
                                                        border policy</a> for more information.
                                                </span>
                                            </div> -->
                  </div>
                  <span *ngIf="
                    !question.id.includes('postcode') &&
                    !(
                      question.id.includes('address') &&
                      !question.id.includes('email')
                    )
                  ">
                    <div *ngIf="
                      submitted &&
                      bookingForm[question.reference].errors?.required
                    " role="alert" tabindex="0" class="invalid-feedback">
                      {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                    </div>
                  </span>
                </ng-container>
              </div>

              <div *ngIf="question.visible && question.detail_type == 'textarea'" class="form-group">
                <label for="{{ question.name }}"><span *ngIf="question.required" aria-hidden="true"
                    class="form-field-required-marker">
                    *</span>
                  {{ question.name }}</label>

                <textarea id="{{ question.reference}}" class="form-control" formControlName="{{ question.reference }}"
                  attr.aria-label="{{ question.name }} text area"></textarea>
                <!-- br instead of changing css -->
                <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br *ngIf="question.help_text" />
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                </span>
              </div>

              <div *ngIf="question.visible && question.detail_type == 'number'" class="form-group">
                <label for="{{ question.name }}"><span *ngIf="question.required" aria-hidden="true"
                    class="form-field-required-marker">
                    *</span>
                  {{ question.name }}</label>

                <input id="{{ question.reference}}" type="text" class="form-control"
                  formControlName="{{ question.reference }}" attr.aria-label="{{ question.name }} input field"
                  (keypress)="keyPressNumberField($event, question.reference)" />
                <!-- br instead of changing css -->
                <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br *ngIf="question.help_text" />
                <div *ngIf="submitted && bookingForm[question.reference].errors?.max" role="alert" tabindex="0"
                  class="invalid-feedback">
                  Please enter a valid {{ question.name }}
                </div>
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                </span>
              </div>

              <div *ngIf="question.visible && question.detail_type == 'date'" class="form-group">
                <label for="{{ question.name }}"><span *ngIf="question.required" aria-hidden="true"
                    class="form-field-required-marker">
                    *</span>
                  {{ question.name }}</label>

                <input id="{{ question.reference}}" type="date" class="form-control"
                  formControlName="{{ question.reference }}" attr.aria-label="{{ question.name }} input field" />
                <!-- br instead of changing css -->
                <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br *ngIf="question.help_text" />
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.pastDate
                    " role="alert" tabindex="0" class="invalid-feedback">
                    {{ bookingForm[question.reference].errors.pastDate.message }}
                  </div>
                </span>
              </div>

              <!-- select dropdown-->
              <div *ngIf="question.visible && question.detail_type == 'dropdown'" class="form-group">
                <label for="{{ question.name }}"><span aria-hidden="true" class="form-field-required-marker"
                    *ngIf="question.required">
                    *</span>
                  {{ question.name }}</label>

                <select id="{{ question.reference}}" formControlName="{{ question.reference }}" [value]="-1"
                  class="form-select" (change)="onQuestionChange()" attr.aria-label="{{ question.name }}">
                  <option></option>
                  <ng-container *ngFor="let option of question.options">
                    <ng-container *ngIf="canAnnualPermit(option.name)">
                      <option [value]="option.name">
                        {{option.name}}
                      </option>
                    </ng-container>
                  </ng-container>
                </select>
                <!-- br instead of changing css -->
                <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br *ngIf="question.help_text" />
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                </span>
              </div>

              <!-- checkbox -->
              <div style="margin-bottom: 0px !important" class="form-group" *ngIf="
                (question.visible && question.detail_type == 'checkbox') ||
                (question.visible && question.detail_type == 'check-price')
              ">
                <div class="bb-flex row-blocks">
                  <mat-checkbox id="{{ question.reference}}" formControlName="{{ question.reference }}"
                    aria-label="{{ question.name }}" (change)="onQuestionChange()">
                    <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                      *
                    </span>
                    <span [innerHTML]="question.name"></span>
                    <span *ngIf="question.price > 0">
                      - {{ question.price / 100 | currency : 'GBP' : true }}</span>
                  </mat-checkbox>
                </div>
                <span *ngIf="question.help_text">
                  <!-- br instead of changing css -->
                  <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                  </span>
                  <br *ngIf="question.help_text" />
                  <br *ngIf="question.help_text" />
                </span>
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    <span *ngIf="question.validationtext">{{question.validationtext}}</span>
                    <span *ngIf="!question.validationtext">{{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate
                      }}</span>
                  </div>
                </span>
                <br />
              </div>

              <!-- radio -->
              <div class="row-blocks form-group" *ngIf="question.visible && question.detail_type == 'radio'">
                <label for="{{ question.name }}">
                  <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">*
                  </span>
                  {{ question.name }}</label>
                <br />

                <mat-radio-group id="{{ question.reference}}" formControlName="{{ question.reference }}"
                  class="col-sm-7 radio-group" (change)="onQuestionChange()">
                  <mat-radio-button class="radio-button" *ngFor="let option of question.options" [value]="option.name">
                    {{ option.name }}
                  </mat-radio-button>
                </mat-radio-group>
                <!-- br instead of changing css -->
                <span *ngIf="question.help_text" class="help-text" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br *ngIf="question.help_text" />
                <span *ngIf="
                  !question.id.includes('postcode') &&
                  !(
                    question.id.includes('address') &&
                    !question.id.includes('email')
                  )
                ">
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                </span>
              </div>
            </ng-container>
          </div>
        </form>
      </div>
    </div>
  </div>
  <br />

  <div class="row mt-4">
    <div class="col-6">
      <button type="button" class="btn btn-primary" (click)="routerGoBack()" title="Back" aria-label="Back to services">
        <span>
          <fa-icon [icon]="faChevronLeft"></fa-icon><span>{{ 'COMMON.BACK' | translate }}</span>
        </span>
      </button>
    </div>
    <div class="col-6">
      <button class="btn btn-primary float-right" type="button" title="Next" aria-label="Submit Application"
        (click)="onSubmit()"
        [disabled]="(!isInLocalArea[localAreaId] && !addressLookupStatusComponent.getAddressLookupUnavailable())  || checkIfNoButtonClicked() || addressUsed || registrationUsed || ((!canRenew() && renewSelected()))">
        <!-- motStatusInvalid || taxStatusInvalid || -->
        <span><span style="padding-right: 20px">Submit</span>
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </span>
      </button>
    </div>
  </div>

  <!-- <div>
        <span>I agree to the details submitted being processed by the re3 partnership for the purpose of managing this
            booking. Please refer to the available re3 <a target="_blank"
                href="https://www.reading.gov.uk/dataprotection"><b>Privacy Notice</b></a>.</span>
        <br><br>
        <span>I confirm that this booking is made for, or on behalf of, a resident of the re3 area and that <b>I
                understand that valid proof of address will be required upon arriving at the recycling
                centre</b>.</span>
    </div> -->
  <br />
  <br />
</div>